"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserSelectionModel", {
    enumerable: true,
    get: function() {
        return UserSelectionModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const UserSelectionModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    creator: _zod.z.union([
        _zod.z.instanceof(_bson.ObjectId),
        _zod.z.null()
    ]),
    deleted: _zod.z.boolean(),
    user_ids: _zod.z.array(_zod.z.instanceof(_bson.ObjectId))
});
